import { registerModal } from "@/shared/lib/modal/modal-registry";
import DateTimeRangeModal from "./date-time-range-modal";
import AutoRefreshModal from "./auto-refresh-modal";
import OnboardingModal from "./onboarding-modal";

registerModal("date-time-range", DateTimeRangeModal, {
  titleKey: "modals.dateTimeRange",
  maxWidth: 400,
});

registerModal("auto-refresh", AutoRefreshModal, {
  titleKey: "modals.autoRefresh",
  maxWidth: 400,
});

registerModal("onboarding", OnboardingModal, {
  maxWidth: 550,
});
